import React, { useRef, useState } from "react";
import Papa from "papaparse";
import { getFunctions, httpsCallable } from "firebase/functions";
import { FirebaseConfig } from "../../../data/firebaseConfig";
import { Button, CircularProgress, Typography } from "@mui/material";

const ImportPeople = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const functions = getFunctions(FirebaseConfig.app);
    const importPeople = httpsCallable(functions, "importPeople");

    // Handle CSV file input
    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            setIsLoading(true);
            setError(null);

            try {
                // Parse the CSV file
                const parsedData = await parseCSV(file);

                // Map the parsed data to the format expected by the Firebase function
                const people = parsedData.map((row: any) => ({
                    firstName: row.firstName,
                    lastName: row.lastName,
                    email: row.email,
                    domainName: row.domainName,
                    username: row.username,
                    externalId: row.externalId,
                    groups: row.groups.split("|").map((group: string) => group.trim()), // Assuming groups are comma-separated
                }));

                // Call the Firebase function with the parsed data
                const result = await importPeople(people);

                console.log("Import Results:", result.data);
            } catch (err) {
                console.error("Error importing recipients:", err);
                setError("Failed to import recipients. Please check your CSV format.");
            } finally {
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
                setIsLoading(false);
            }
        }
    };

    // Parse CSV using PapaParse
    const parseCSV = (file: File) => {
        return new Promise<any[]>((resolve, reject) => {
            Papa.parse(file, {
                complete: (result: { data: any[] | PromiseLike<any[]>; }) => {
                    resolve(result.data);
                },
                error: (error: { message: any; }) => {
                    reject(error.message);
                },
                header: true, // assumes the first row contains headers
                skipEmptyLines: true, // skip empty lines
            });
        });
    };

    return (
        <div style={{ textAlign: 'center' }}>
            <input
                type="file"
                accept=".csv"
                onChange={handleFileChange}
                style={{ display: 'none' }}
                id="people-input"
                ref={fileInputRef}
            />
            <label htmlFor="logo-upload-input" style={{ display: 'block' }}>
                <Button variant="outlined" color="secondary" style={{}} disabled={isLoading}
                    onClick={() => fileInputRef.current?.click()}>
                    {isLoading ? <CircularProgress size={24} /> : 'Import Recipients...'}
                </Button>
            </label>

            {error && <Typography color="error">{error}</Typography>}
        </div>
    );
};

export default ImportPeople;
